import {createReducer} from "redux-act";
import {ICommonReducer, IReducerAction} from "modules/types";
import {toggleMenu} from "modules/actions";

const initialState: ICommonReducer = {
	isMenuOpen: false,
};

type ICommonReducerPayload<TP = null> = IReducerAction<ICommonReducer, TP>;

const onToggleMenu: ICommonReducerPayload<boolean> = (state, payload) => ({
	...state,
	isMenuOpen: payload,
});

export const common = createReducer({}, initialState).on(toggleMenu, onToggleMenu);
